export default "__VITE_PUBLIC_ASSET__a569c8f8__"